export default __webpack_public_path__ + "static/media/payroll-component-empty.69704451.svg";